import { render, staticRenderFns } from "./MedicationDetailNew.vue?vue&type=template&id=d25564bc&scoped=true"
import script from "./MedicationDetailNew.vue?vue&type=script&lang=js"
export * from "./MedicationDetailNew.vue?vue&type=script&lang=js"
import style0 from "./MedicationDetailNew.vue?vue&type=style&index=0&id=d25564bc&prod&lang=scss&scoped=true"
import style1 from "./MedicationDetailNew.vue?vue&type=style&index=1&id=d25564bc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d25564bc",
  null
  
)

export default component.exports